import React, { useEffect, useState } from 'react';
import styles from '../styles';
import {
  RBHAlert,
  RBHBox,
  RBHButton,
  RBHSteps,
  RBHTable,
  RBHText,
  RBHTextInput
} from '../../../../../../shared/components';
import { Breadcrumb, Empty, Form, Row, Space, Steps } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import styleText from '../../../../../../shared/components/rbh-text/styles';
import { mainCreators } from '../../../../../main-action';
import { MAIN_STATE_KEY } from '../../../../../main-reducer';
import metrics from '../../../../../../shared/theme/metrics';
import { httpCreators, MenuModifierItemValidator, useLoadingSelector } from 'rbh-merchant-core';
import { generalCreators } from '../../../../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../../../../redux/general/general-reducer';
import { MODAL_TYPE } from '../../../../../../redux/general/general-constant';
import { POS_STATE_KEY, posStateSelector } from '../../redux/pos-reducer';
import { BUTTON_FLAG, POS_REQUEST_ID_LIST } from '../../redux/pos-constant';
import { posSagas } from '../../redux/pos-saga';
import { PosService } from '../../redux/pos-service';
import { Branch } from '../../../../../../shared/models/branch';
import './styles.css';
import { posCreators } from '../../redux/pos-action';

export const PosStep2Screen: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const history = useHistory();
  const loading = useLoadingSelector(POS_REQUEST_ID_LIST.GET_MENU_MODIFIER_ITEM);
  const shopData = useSelector(posStateSelector(POS_STATE_KEY.POS_SHOP_DATA)) as Branch;
  const menuModifierItemData = useSelector(posStateSelector(POS_STATE_KEY.POS_MENU_MODIFIER_ITEM)) as [];
  const [formInvalid, setFormInvalid] = useState(false);
  const alertSuccess = useSelector(posStateSelector(POS_STATE_KEY.ALERT_SUCCESS));

  useEffect(() => {
    dispatch(mainCreators.setMainState(MAIN_STATE_KEY.HEADER_MENU, 1));
    if (!shopData) {
      toPath('/main/posmanagement');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      callMenuModifierItem();
    }
  }, []);

  const resetReload = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    form.resetFields();
    callMenuModifierItem();
  };

  const callMenuModifierItem = () => {
    dispatch(httpCreators.request({
      id: POS_REQUEST_ID_LIST.GET_MENU_MODIFIER_ITEM,
      sagaHandler: posSagas.getPosMenuModifierItemHandler as any,
      callbackParams: { resetReload },
      service: PosService.getMenuModifierItem,
      serviceParams: shopData.shopId
    }));
  };

  const toPath = (path: string) => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push(path);
  };

  const trimFieldValue = (fieldName: string) => {
    const value = form.getFieldValue(fieldName);
    if (value) {
      form.setFieldsValue({
        [fieldName]: value.trim()
      });
      form.validateFields([fieldName]);
    }
  };

  const checkFormInvalid = () => {
    let invalid = false;
    const values = form.getFieldsValue();
    for (const key in values) {
      if (MenuModifierItemValidator.menuModifierItemSKUId.isError(values[key])) {
        invalid = true;
        break;
      }
    }
    setFormInvalid(invalid);
  };

  const onFinish = (buttonFlag: string, afterStep2Save?: any) => {
    const error = form.getFieldsError();
    const foundError = error.find(({ errors }) => errors.length > 0);
    if (foundError) {
      dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
      form.scrollToField(foundError.name[0], { behavior: 'smooth' });
    } else {
      const newMenuModifierItem = menuModifierItemData.map((value: any, i: number) => {
        return {
          menuModifierItemId: value.menuModifierItemId,
          menuModifierItemSKUId: form.getFieldValue(`menuModifierItemSKUId-${i}`)
        };
      });
      const shopId = shopData?.shopId;
      let body = { menuModifierItems: newMenuModifierItem, shopId, buttonFlag };
      if (buttonFlag === BUTTON_FLAG.SAVE_AND_NEXT_STEP && menuModifierItemData.length === 0 || buttonFlag === BUTTON_FLAG.BACK_ONLY) {
        body = { menuModifierItems: [], shopId, buttonFlag };
      }
      dispatch(httpCreators.request({
        id: POS_REQUEST_ID_LIST.PATCH_POS_MENUS,
        sagaHandler: posSagas.patchPosMenuModifierItemHandler as any,
        callbackParams: { afterStep2Save },
        service: PosService.patchMenuModifierItem,
        serviceParams: body
      }));
    }
  };

  const cancelPos = () => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
      visible: true,
      modalImageId: 'cancelPos-alert-img',
      modalTitle: 'main.posManagement.posActivate.popup.cancelPos.header',
      modalTitleId: 'cancelPos-header-text',
      modalContent: 'main.posManagement.posActivate.popup.cancelPos.content',
      modalContentId: 'cancelPos-content-text',
      onOkText: 'main.posManagement.posActivate.popup.cancelPos.ok',
      onOkTextId: 'cancelPos-ok-text',
      onCancelText: 'main.posManagement.posActivate.popup.cancelPos.cancel',
      onCancelTextId: 'cancelPos-cancel-text',
      onConfirm: () => {
        dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
        dispatch(httpCreators.request({
          id: POS_REQUEST_ID_LIST.PATCH_CANCEL_POS,
          sagaHandler: posSagas.patchCancelPosHandler as any,
          service: PosService.patchCancelPos,
          serviceParams: { shopId: shopData.shopId },
          callbackParams: {
            alertCancelPosSuccess: () => dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_CANCEL_POS_SUCCESS, true)),
            alertCancelPosFail: () => dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_CANCEL_POS_FAIL, true)),
            toPath
          },
        }));
      },
      type: MODAL_TYPE.CONFIRM_EDIT
    }));
  };

  const columns = [
    {
      width: metrics.tableHeader.width300,
      title: <FormattedMessage id={'main.posManagement.posActivate.step2.table.menuModifierName'} />,
      dataIndex: 'menuModifierItemName',
      align: 'left',
      render: (value: string, all: any, index: number) => {
        const menuModifierItemNameId = `menuModifierItemName-${index}`;
        return (
          <RBHBox style={{ width: metrics.tableHeader.width300 }} id={menuModifierItemNameId}>
            {value}
          </RBHBox>
        );
      }
    },
    {
      width: metrics.tableHeader.width100,
      title: <FormattedMessage id={'main.posManagement.posActivate.step2.table.menuModifierPrice'} />,
      dataIndex: 'menuModifierItemPrice',
      align: 'right',
      render: (value: any, all: any, index: number) => {
        const menuModifierItemPriceId = `menuModifierItemPrice-${index}`;
        return (
          <RBHBox style={{ width: metrics.tableHeader.width100 }} id={menuModifierItemPriceId}>
            {value}
          </RBHBox>
        );
      }
    },
    {
      width: metrics.tableHeader.width300,
      title: <FormattedMessage id={'main.posManagement.posActivate.step2.table.menuModifierSku'} />,
      dataIndex: 'menuModifierItemSKUId',
      render: (value: any, all: any, index: number) => {
        const menuModifierItemSKUId = `menuModifierItemSKUId-${index}`;
        // validate initialValue
        if (!!value && MenuModifierItemValidator.menuModifierItemSKUId.isError(value)) {
          form.validateFields([menuModifierItemSKUId]);
          form.scrollToField(menuModifierItemSKUId, { behavior: 'smooth' });
        }
        return (
          <RBHBox style={{ width: metrics.tableHeader.width300 }}>
            <Form className={'customWidth'} size='large' style={styleText.formText} form={form} onFieldsChange={checkFormInvalid} >
              <Form.Item className={'posStep2MenuModifierItemSKUId'} colon={false}
                name={menuModifierItemSKUId} validateTrigger={['onChange', 'onBlur']}
                initialValue={value ? value : ''}
                rules={[
                  {
                    pattern: MenuModifierItemValidator.menuModifierItemSKUId.regexPattern,
                    message: <FormattedMessage id={'main.form.text.valid'} />
                  }
                ]}
              >
                <RBHTextInput id={menuModifierItemSKUId} placeholder={'main.posManagement.posActivate.step2.table.form.menuModifier.placeholder'}
                  onBlur={() => trimFieldValue(menuModifierItemSKUId)} autoComplete='off' data-testid={menuModifierItemSKUId}
                  maxLength={MenuModifierItemValidator.menuModifierItemSKUId.maxLength} />
              </Form.Item>
            </Form>
          </RBHBox>
        );
      },
    }
  ];

  setTimeout(() => {
    if (alertSuccess) {
      dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_SUCCESS, false));
    }
  }, 3000);

  const handleSuccessClose = () => {
    dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_SUCCESS, false));
  };

  const isAlert = () => {
    if (alertSuccess) {
      return (
        <RBHBox id={'posActivate-alert-step2-success'} data-testid={'posActivate-alert-step2-success'}>
          <RBHAlert type={'success'} text={'main.posManagement.posActivate.step1.alert.success'}
            afterClose={handleSuccessClose} /><br />
        </RBHBox>
      );
    }
  };

  const BreadcrumbRender = () => {
    return (
      <RBHBox>
        <Breadcrumb style={styleText.breadCrumb}>
          <Breadcrumb.Item>
            <a data-testid={'posmanagement-tohomepage-breadcrumb'}
              id={'posmanagement-tohomepage-breadcrumb'} style={styleText.breadCrumbItemLink}
              onClick={() =>
                dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                  visible: true,
                  onSaveAndLeave: () => {
                    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
                    onFinish(BUTTON_FLAG.SAVE_ONLY,
                      () => { toPath('/main'); });
                  },
                  onLeaveOnly: () => { toPath('/main'); },
                  type: MODAL_TYPE.POS_LEAVE_STEP_CONFIRM
                }))}>
              <FormattedMessage id={'main.main'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a data-testid={'branchmanagement-breadcrumb'}
              id={'branchmanagement-breadcrumb'} style={styleText.breadCrumbItemLink}
              onClick={() => dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true,
                onSaveAndLeave: () => {
                  dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
                  onFinish(BUTTON_FLAG.SAVE_ONLY,
                    () => { toPath('/main/branchmanagement'); });
                },
                onLeaveOnly: () => { toPath('/main/branchmanagement'); },
                type: MODAL_TYPE.POS_LEAVE_STEP_CONFIRM
              }))}>
              <FormattedMessage id={'main.branchmanagement'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a data-testid={'posManagement-breadcrumb'}
              id={'posManagement-breadcrumb'} style={styleText.breadCrumbItemLink}
              onClick={() => dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true,
                onSaveAndLeave: () => {
                  dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
                  onFinish(BUTTON_FLAG.SAVE_ONLY,
                    () => { toPath('/main/posmanagement'); });
                },
                onLeaveOnly: () => { toPath('/main/posmanagement'); },
                type: MODAL_TYPE.POS_LEAVE_STEP_CONFIRM
              }))}>
              <FormattedMessage id={'main.posManagement.landing.posManagement'} />
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span data-testid={'posActivate-breadcrumb'}
              id={'posActivate-breadcrumb'} style={styleText.breadCrumbItem}>
              <FormattedMessage id={'main.posManagement.breadcrumb.activate.pos'} />
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </RBHBox>
    );
  };

  const headerRender = () => {
    return (
      <RBHBox style={styles.header}>
        <RBHText data-testid={'posActivate-step2-header'} id={'posActivate-step2-header'}
          style={styleText.headerText} text={'main.posManagement.breadcrumb.activate.pos'} />
        <RBHText data-testid={'cancel-posActivate-step2'} id={'cancel-posActivate-step2'}
          style={styles.regularPurple14under} text={'main.posManagement.posActivate.cancelActivatePos'}
          onClick={cancelPos} />
      </RBHBox>
    );
  };

  const posStepText = (step: number) => {
    if (step === 1) {
      return (
        <RBHBox>
          <RBHText data-testid={'posActivate-step1-1'} id={'posActivate-step1-1'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step1.1'} />
          <RBHText data-testid={'posActivate-step1-2'} id={'posActivate-step1-2'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step1.2'} />
        </RBHBox>
      );
    } else if (step === 2) {
      return (
        <RBHBox>
          <RBHText data-testid={'posActivate-step2-1'} id={'posActivate-step2-1'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step2'} />
        </RBHBox>
      );
    } else if (step === 3) {
      return (
        <RBHBox>
          <RBHText data-testid={'posActivate-step3-1'} id={'posActivate-step3-1'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step3.1'} />
          <RBHText data-testid={'posActivate-step3-2'} id={'posActivate-step3-2'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step3.2'} />
        </RBHBox>
      );
    } else if (step === 4) {
      return (
        <RBHBox>
          <RBHText data-testid={'posActivate-step4'} id={'posActivate-step4'}
            style={styles.regular16fakeBlack} text={'main.posManagement.posActivate.step4'} />
        </RBHBox>
      );
    }
  };

  const stepRender = () => {
    const { Step } = Steps;
    return (
      <RBHSteps current={1} type={'default'} className={'posStep'} style={styles.paddingBottom20}>
        <Step style={styles.regular16fakeBlack} title={posStepText(1)} />
        <Step style={styles.regular16fakeBlack} title={posStepText(2)} />
        <Step style={styles.regular16fakeBlack} title={posStepText(3)} />
        <Step style={styles.regular16fakeBlack} title={posStepText(4)} />
      </RBHSteps>
    );
  };

  const shopNameAndDescRender = () => {
    return (
      <RBHBox>
        <RBHBox style={{ display: 'flex' }}>
          <RBHText data-testid={'posActivate-shopNameLabel'} id={'posActivate-shopNameLabel'}
            style={styles.medium16fakeBlackTop} text={'main.posManagement.posActivate.shopNameLabel'} />&nbsp;
          <RBHText style={styles.regular16DarkGray}>{shopData?.shopName}</RBHText>
        </RBHBox>
        <RBHBox style={styles.line} />
        <RBHText data-testid={'posActivate-menuModifierItemDescLabel'} id={'posActivate-menuModifierItemDescLabel'}
          style={styles.medium16fakeBlackBottom} text={'main.posManagement.posActivate.step2.contentTitle'} />
        <RBHText data-testid={'posActivate-menuModifierItemDesc'} id={'posActivate-menuModifierItemDesc'}
          style={styles.regular14DarkGray} text={'main.posManagement.posActivate.step2.contentDetail'} />
      </RBHBox>
    );
  };

  const tableRender = () => {
    return (
      <RBHBox style={styles.defaultContent}>
        {shopNameAndDescRender()}
        <RBHTable
          locale={{
            emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<span> <FormattedMessage id={'main.posManagement.posActivate.step2.table.notFound'} /> </span>} />
          }}
          rowKey={'menuModifierItemId'}
          columns={columns}
          dataSource={menuModifierItemData}
          scroll={{ y: 297 }}
          pagination={false} />
      </RBHBox>
    );
  };

  const buttonsRender = () => {
    return (
      <RBHBox style={styles.boxButtonStep2}>
        <Row justify={'space-between'} align={'middle'}>
          <RBHButton
            id={'posActivate-buttonBackToPrevious'}
            style={styles.buttonFromCancelGradient}
            type='primary'
            htmlType='button'
            onClick={() => {
              dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
                visible: true,
                onOk: () => {
                  dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
                  onFinish(BUTTON_FLAG.BACK_AND_SAVE,
                    () => { toPath('/main/posmanagement/step1'); });
                },
                onCancel: () => {
                  dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false }));
                  onFinish(BUTTON_FLAG.BACK_ONLY,
                    () => { toPath('/main/posmanagement/step1'); });
                },
                type: MODAL_TYPE.BACK_TO_PREVIOUS
              }));
            }}
            text={'main.posManagement.posActivate.buttonBackToPrevious'}
            data-testid={'posActivate-buttonBackToPrevious'} />
          {menuModifierItemData.length === 0 ?
            <RBHButton
              id={'posActivate-buttonNextOnly'}
              style={styles.buttonFromConfirmGradient}
              type='primary'
              htmlType='button'
              onClick={() => {
                onFinish(BUTTON_FLAG.SAVE_AND_NEXT_STEP,
                  () => {
                    toPath('/main/posmanagement/step3');
                  });
              }}
              text={'main.posManagement.posActivate.step2.button.next'}
              data-testid={'posActivate-buttonNextOnly'} />
            :
            <Space size={'middle'}>
              <RBHButton
                id={'posActivate-buttonSaveOnly'}
                style={styles.buttonFromCancelGradient}
                type='primary'
                htmlType='button'
                onClick={() => {
                  onFinish(BUTTON_FLAG.SAVE_ONLY,
                    () => {
                      dispatch(posCreators.setPosState(POS_STATE_KEY.ALERT_SUCCESS, true));
                      resetReload();
                    });
                }}
                text={'main.posManagement.posActivate.buttonSaveOnly'}
                data-testid={'posActivate-buttonSaveOnly'} />
              <RBHButton
                id={'posActivate-buttonSaveAndNext'}
                style={styles.buttonFromConfirmGradient}
                type='primary'
                htmlType='button'
                onClick={() => {
                  onFinish(BUTTON_FLAG.SAVE_AND_NEXT_STEP,
                    () => {
                      toPath('/main/posmanagement/step3');
                    });
                }}
                disabled={formInvalid}
                text={'main.posManagement.posActivate.buttonSaveAndNext'}
                data-testid={'posActivate-buttonSaveAndNext'} />
            </Space>
          }
        </Row>
      </RBHBox>
    );
  };

  return (
    <RBHBox>
      {isAlert()}
      {BreadcrumbRender()}
      <RBHBox>
        {headerRender()}
        {stepRender()}
        {loading ? null :
          <RBHBox>
            {tableRender()}
            {buttonsRender()}
          </RBHBox>
        }
      </RBHBox>
    </RBHBox>
  );
};

type Props = {};
